import React, { Fragment, useEffect, useState } from 'react';
import Navbar from '../layouts/Navbar';
import Footer from '../layouts/Footer';
import axios from 'axios';
import { Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';

const Publications = ()=>{
    const uri = useSelector(state=>state.uri)
    const [publications, setPublications] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [arr,] = useState([1,2,3,4])

    useEffect(()=>{
        axios.get(
            `${uri}publications`
        ).then(res=>{
            setPublications(res.data.data)
            setIsLoading(false)
        }).catch(err=>{
            setIsLoading(false)
            // setError(err.message)
        })
    }, [])
    return (
        <Fragment>
            <Navbar />
            <div className='mt-5'>
                <div className='p-5 bg-yrh' data-aos='fade-in'>
                    <p className='text-white fs-1 text-center pt-3'>
                        Explore different publication from our members
                    </p>
                </div>
                <div className='d-flex justify-content-center mt-5 mb-4 px-5'>
                    <div className='col-md-6'>
                        <p className='text-yrh text-center fw-bold fs-4 my-0'>Recent Publications</p>
                        <hr className='my-0 text-line' />
                    </div>
                </div>
            </div>
            {
                isLoading
                ?
                <div className='container'>
                    <ol className='pb-5'>
                        {
                            arr.map((each, i)=>(
                                <Skeleton variant='text' className='py-3' />
                            ))
                        }
                    </ol>
                </div>
                :
                publications.length !== 0
                ?
                <div className='container'>
                    <ol className='pb-5'>
                        {
                            publications.map((each, i)=>(
                                <li key={i} className='fs-5 text-yrh py-3' data-aos='fade-up'>
                                    <strong className='cursor-pointer' onClick={()=>window.open(each.link)}>{each.title}</strong> {each.authors}
                                </li>
                            ))
                        }
                    </ol>
                </div>                
                :
                <div className='container'>
                    <p className='fs-5 text-yrh fst-italic pb-5'>
                        No recent publications at the moment, check back later...
                    </p>
                </div>
            }
            <Footer />
        </Fragment>
    )
}

export default Publications